/**
 * @deprecated Use CREHANA_BASE_URL_PRD instead
 */
export var CREHANA_ROOT_URL = 'https://www.crehana.com';
export var LOGOUT_URL = '/logout/';
export var CREHANA_DOMAIN_PRD = 'crehana.com';
export var CREHANA_HOSTNAME_PRD = 'www.crehana.com';
export var CREHANA_BASE_URL_PRD = 'https://www.crehana.com';
export var CREHANA_DOMAIN_QA = 'creha.co';
export var CREHANA_HOSTNAME_QA = 'qa.creha.co';
export var CREHANA_BASE_URL_QA = 'https://qa.creha.co';
export var CREHANA_BASE_URL_SEO_PRD = 'https://www.crehana.com';
export var CREHANA_HOSTNAME_SEO_PRD = 'www.crehana.com';